<template>
    <div class="my-6 mb-12">
        <!-- <v-navigation-drawer
            v-model="fileUploadDialog"
            app
            relative
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="sansation_subtitle accent darken-2 white--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                         Upload Client Files
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="white"
                            elevation="1"
                            @click="closeClientUploads">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-3">
                    < !-- <UploadClientFiles 
                        :projectData="projectDetails"
                        :moduleKey="projectDetails.modinfo.module_key"
                        :projectId="projectDetails.project_id"
                        :userId="projectDetails.user_id"
                        :isDeliverable="false"
                        :isIndependent="true"
                        @triggerUserFeedback="triggerUserFeedback"
                        @closeClientUploads="closeClientUploads"
                        @refreshDocs="refreshDocs"
                    /> -- >
                </v-card-text>
            </v-card>
        </v-navigation-drawer> -->


        <div class="d-flex d-block align-center mb-2">
            <div class="sansation label_medium info--text d-inline">Project Resources</div>
            <!-- <v-btn
                v-if="projectDetails.module_key == 'buyer'"
                icon
                x-small
                class="ml-3 mt-n1 primary--text text--darken-1 d-inline"
                :style="refresh_docs ? 'border:none' : 'border:1px solid #3b9ba7'"
                :loading="refresh_docs"
                @click="refreshDocs()">
                <v-icon v-if="!refresh_docs"
                    small
                    class="primary--text text--darken-1">
                    mdi-autorenew
                </v-icon>
            </v-btn> -->
            <div class="d-inline ml-4 info--text">{{ (projectResources.resources.length) }} file{{ (projectResources.resources.length) == 1 ? '':'s' }}</div>
            <!-- <v-spacer></v-spacer>
            <div class="d-inline">
                <v-btn
                    small
                    class="ml-6 d-inline menu_bg_primary primary--text text--darken-1"
                    elevation=0
                    @click="fileUploadDialog = true">
                    Upload Resources Files
                    <v-icon small color="primary" class="ml-2" right>mdi-cloud-upload</v-icon>
                </v-btn>
            </div> -->
        </div>


        <v-data-table
            v-if="projectResources.resources.length"
            :headers="resources_header"
            :items="projectResources.resources"
            disable-pagination
            hide-default-header
            hide-default-footer>

            <template v-slot:header="{ props }">
                <thead>
                    <tr class="justify-space-between">
                        <th v-for="header in props.headers" :key="header.value">
                            <div class="d-inline">{{ header.text }}</div>
                            <v-tooltip v-if="header.tooltip" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        class="d-inline"
                                        color="primary">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>{{ header.tooltip }}</span>
                            </v-tooltip>
                        </th>
                    </tr>
                </thead>
            </template>

            <template v-slot:body="{ items }">
                <tbody name="list" is="transition-group">
                    <tr v-for="item in items" :key="item.file_id" class="item-row avenir_book table_body d-flex-row">
                        <td width="22%">
                            <a v-if="!item.type.includes('video')" :href="item.url" class="clean_link" target="_blank">{{ item.client_label }}</a>
                            <a v-else @click="openVideo( { fileid: item.file_id, url: item.url, title: item.client_label, type: item.type, access: 'resource_docs' } )">{{ item.client_label }}</a>    
                        </td>
                        <td width="24%">{{ item.admin_label }}</td>
                        <td width="" v-html="item.description"></td>
                        <td width="8%">
                            <v-switch
                                :key="item.file_id"
                                v-model="item.is_visible"
                                hide-details
                                color="primary darken-1"
                                class="my-3"
                                @click="resourceVisibility( 
                                    {   user_id: projectResources.user_id, 
                                        project_id: projectResources.project_id, 
                                        resource_visibility: projectResources.resource_visibility, 
                                        file_id: [item.file_id], 
                                        is_visible: item.is_visible
                                    }, 'resource' )">
                            </v-switch>    
                        </td>
                        <td class="text-right" width="12%">
                            <v-switch
                                :key="item.file_id"
                                v-model="item.is_visible_overview"
                                hide-details
                                color="primary darken-1"
                                class="my-3"
                                @click="resourceVisibility( 
                                    {   user_id: projectResources.user_id, 
                                        project_id: projectResources.project_id, 
                                        resource_visibility: projectResources.resource_visibility, 
                                        file_id: [item.file_id], 
                                        is_visible: item.is_visible_overview
                                    }, 'overview' )">
                            </v-switch>    
                        </td>
                    </tr>                    
                </tbody>
            </template>
        </v-data-table>
    </div>
</template>


<script>  
    import dateFormat, { masks } from "dateformat";

    export default {
        name: 'ProjectResources',

        props: {
            projectResources: Object,
            toggleVisiblity: Function,
            playResourceVideo: Function,
        },

        data () {
            return {
                resources_header: [   
                    {   text: 'Client Label',     
                        value: 'client_label',    
                        align: 'start',  
                        sortable: true
                    },
                    {   text: 'Admin Label',     
                        value: 'admin_label',    
                        align: 'start',  
                        sortable: true
                    },
                    {   text: 'Description',     
                        value: 'description',
                        align: 'start',    
                        sortable: true 
                    },
                    {   text: 'Visible',     
                        value: 'is_visible',
                        tooltip: 'These are files and/or videos that will show up in the lower Resource Documents area of the Roadmap page, when toggled on.',
                        align: 'start',    
                        sortable: true
                    },
                    {   text: 'Stage Visible',     
                        value: 'is_visible_overview',
                        tooltip: 'These are files and/or videos that will show up within the text of a roadmap step description, when toggled on.',
                        align: 'start',    
                        sortable: true
                    }
                ]
            }
        },
        
        methods: {
            openVideo ( data ) {
                this.$emit('playResourceVideo', data )
            },

            resourceVisibility ( data, type ) {
                this.$emit('toggleVisiblity', data, type )
            },
            
            formatDate: function ( date, mask ) {
                return dateFormat(date, mask)
            }
        },

        mounted () {
            // console.log(this.projectResources.resources)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table_body td {
        padding-top: .5rem !important; 
        padding-bottom: .5rem !important;
        vertical-align: top !important;
    }
    .clean_link {
        text-decoration: none;
    }
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectResources.vue